import * as Tone from "tone";
import type { GameEvent } from "../shared/types";

type CombatEvent = Omit<GameEvent, "type"> & {
  type: GameEvent["type"] | "pickup_collected";
  source?: "regular" | "homing" | "mine" | "pickup";
};

export class CombatAudio {
  private started = false;
  private torpedo?: Tone.Synth;
  private hit?: Tone.NoiseSynth;
  private status?: Tone.Synth;
  private pickup?: Tone.Synth;
  private mine?: Tone.MembraneSynth;

  async start(): Promise<void> {
    if (this.started) return;
    await Tone.start();
    this.torpedo = new Tone.Synth({
      oscillator: { type: "triangle" },
      envelope: { attack: 0.01, decay: 0.08, sustain: 0.1, release: 0.16 }
    }).toDestination();
    this.hit = new Tone.NoiseSynth({
      noise: { type: "white" },
      envelope: { attack: 0.01, decay: 0.16, sustain: 0, release: 0.08 }
    }).toDestination();
    this.status = new Tone.Synth({
      oscillator: { type: "sine" },
      envelope: { attack: 0.02, decay: 0.12, sustain: 0.2, release: 0.2 }
    }).toDestination();
    this.pickup = new Tone.Synth({
      oscillator: { type: "sine" },
      envelope: { attack: 0.005, decay: 0.08, sustain: 0.12, release: 0.18 }
    }).toDestination();
    this.mine = new Tone.MembraneSynth({
      pitchDecay: 0.04,
      octaves: 5,
      envelope: { attack: 0.001, decay: 0.22, sustain: 0.02, release: 0.12 }
    }).toDestination();
    this.started = true;
  }

  playEvent(event: CombatEvent): void {
    if (!this.started) return;
    if (event.type === "torpedo_fired") {
      this.torpedo?.triggerAttackRelease(event.source === "homing" ? "G3" : "C3", event.source === "homing" ? "8n" : "16n");
    } else if (event.type === "mine_deployed") {
      this.mine?.triggerAttackRelease("A1", "8n");
    } else if (event.type === "player_damaged") {
      if (event.source === "mine") {
        this.mine?.triggerAttackRelease("C1", "4n");
      } else {
        this.hit?.triggerAttackRelease(event.source === "homing" ? "8n" : "12n");
      }
    } else if (event.type === "player_sunk") {
      this.mine?.triggerAttackRelease("F1", "4n");
      this.hit?.triggerAttackRelease("8n");
    } else if (event.type === "pickup_collected") {
      this.pickup?.triggerAttackRelease(event.source === "pickup" ? "E5" : "C5", "16n");
    } else if (event.type === "match_started" || event.type === "match_finished") {
      this.status?.triggerAttackRelease(event.type === "match_started" ? "G4" : "C5", "8n");
    }
  }
}
